/**
 * Classification display helpers (TAG / CARD DISPLAY ONLY).
 *
 * `cleanClassification` removes the word "Chamka" (case-insensitive) from a
 * classification name wherever it appears, tidying up any separators left
 * behind. This is a DISPLAY transform only — the stored classification is
 * never changed.
 *
 * Examples:
 *   "EM-Chamka"      -> "EM"
 *   "Chamka-EM"      -> "EM"
 *   "EM Chamka"      -> "EM"
 *   "EM-Chamka-OV"   -> "EM-OV"
 *   "EMChamka"       -> "EM"
 *   "RB-Chamka Fine" -> "RB-Fine"
 *   "Chamka"         -> "—"  (nothing left to show)
 */

const SEP_RUN = /[\s\-_/.]{2,}/g;

function dominantSep(run) {
  if (run.includes('-')) return '-';
  if (run.includes('_')) return '_';
  if (run.includes('/')) return '/';
  if (run.includes('.')) return '.';
  return ' ';
}

export function cleanClassification(raw) {
  if (raw == null) return raw;
  let s = String(raw);
  if (!/chamka/i.test(s)) return s; // fast path — nothing to do

  // Split keeping separators so we can drop/strip only the word tokens.
  const parts = s.split(/([\s\-_/.]+)/);
  s = parts
    .map((p) => (/^[\s\-_/.]+$/.test(p) ? p : p.replace(/chamka/gi, '')))
    .join('');

  // Trim separator chars from the edges, then collapse any internal runs of
  // separators (created by the removal) down to a single sensible separator.
  s = s.replace(/^[\s\-_/.]+|[\s\-_/.]+$/g, '');
  s = s.replace(SEP_RUN, (m) => dominantSep(m));
  s = s.trim();

  return s || '—';
}

export default cleanClassification;
